export default $(()=>{
    /* --------------------------------------------------------------------
     * StylingGT - A Javascript plug-in
     * Author: Winner Crespo, http://winnercrespo.com
     * Copyright (c) 2014 Winner Crespo
     * Licensed under The MIT License (MIT) [http://opensource.org/licenses/MIT]
     * --------------------------------------------------------------------
     */

    function defaultStyle(remove, leftIcon, centerText, rightIcon, borderColor, backgroundColor, textColor, textSize, className){
        if(remove){
            removeLeftIcon();
        }
        changeLeftIcon(leftIcon);
        changeCenterText(centerText);
        changeRightIcon(rightIcon);
        changeBorderColor(borderColor);
        changeBackgroundColor(backgroundColor);
        changeTextColor(textColor);
        changeTextSize(textSize);
        changeRightIconWithFA(className);
        show();
    }

    function removeLeftIcon(){
        $("#google_translate_element img").eq(0).remove();
    }

    function changeLeftIcon(url){
        if(url != ''){
            $("#google_translate_element img").eq(0).css("background-image", "");
            $("#google_translate_element img").eq(0).attr("src", url);
            $("#urlLeftIcon").val('');
        }
    }

    function changeLeftIconWithFA(className, css) {
        var i = $('<i>').addClass(className).css(css);
        $("#google_translate_element img").eq(0).before(i).remove();
    }

    function changeCenterText(text){
        if(text != ''){
            $("#google_translate_element span").eq(1).text(text);
            $("#centerText").val('');
        }
    }

    function changeRightIcon(text){
        if(text != ''){
            $("#google_translate_element span").eq(3).text(text);
            $("#rightIcon").val('');
        }
    }

    function changeRightIconWithFA(className) {
        if(className != ''){
            $("#google_translate_element span").eq(3).text('').addClass(className);
            $("#rightIcon").val('');
        }
    }

    function changeBorderColor(color){
        if(color != ''){
            $("#google_translate_element span").css("border-color", color);
            $("#google_translate_element div").eq(1).css("border-color", color);
            $("#borderColor").val('');
        }
    }

    function changeGeneralCSS(css){
        $("#google_translate_element div").eq(1).css(css);
    }

    function changeBackgroundColor(color){
        if(color != ''){
            $("#google_translate_element div").eq(1).css("background-color", color);
            $("#backgroundColor").val('');
        }
    }

    function changeTextColor(color){
        if(color != ''){
            $("#google_translate_element a").css("color", color);
            $("#textColor").val('');
        }
    }

    function changeTextSize(size){
        if(size != ''){
            $("#google_translate_element a").css("font-size", size);
            $("#textSize").val('');
        }
    }

    function show(){
        $("#google_translate_element").show();
    }

    setTimeout(
        function(){
            changeCenterText('Translate');
            changeTextSize('12px');
            changeRightIconWithFA('fa fa-chevron-circle-down');
            changeLeftIconWithFA('fa fa-google', {
                'font-size': '14px',
                'vertical-align': 'middle',
                'margin-left': '3px',
            });
            changeGeneralCSS({
                'border-color': '#005293',
            });
            show();
        },
        1000
    );
});